// Mock data for BAHUBALI CABS website
// Theme: Royal Rajasthan + Aravalli Range

/* ================= HERO ================= */

export const heroData = {
  headline: "BAHUBALI CABS",
  subheadline: "Trusted Cab Service in Udaipur",
  description:
    "Your premium partner for local, airport & outstation taxi services in Udaipur, Rajasthan. Experience royal comfort on every journey.",

  phone: "+91 70141 31352",
  whatsapp: "917014131352",

  backgroundImage: "/images/bahubali.jpg",
  bookingBackground: "/images/bahubaliback.jpg",
};

/* ================= SERVICES ================= */

export const servicesData = [
  {
    id: 1,
    title: "Udaipur Local Cab Service",
    description:
      "Explore the City of Lakes with reliable local taxi service for sightseeing and daily travel.",
    icon: "MapPin",
    backgroundImage: "/images/udaipur3.jpg",
  },
  {
    id: 2,
    title: "Airport Pickup & Drop",
    description:
      "On-time airport transfers with clean AC vehicles and professional drivers.",
    icon: "Plane",
    backgroundImage: "/images/car 7.jpeg",
  },
  {
    id: 3,
    title: "Outstation Cab Service",
    description:
      "Comfortable outstation taxis from Udaipur to Rajasthan & Gujarat cities.",
    icon: "Car",
    backgroundImage: "/images/car 14.jpeg",
  },

  {
    id: 4,
    title: "One-Way & Round Trip",
    description:
      "Pay only for one-way or enjoy affordable round-trip packages.",
    icon: "Route",
    backgroundImage: "/images/car 11.jpeg",
  },
  {
    id: 5,
    title: "Family & Corporate Travel",
    description:
      "Spacious vehicles for family trips, corporate travel & group tours.",
    icon: "Users",
    backgroundImage: "/images/car 9.jpeg",
  },
];

/* ================= ROUTES ================= */
/* (UNCHANGED – already correct) */

/* ================= ROUTES ================= */

const defaultPricing = [
  { vehicle: "Sedan", oneWay: "On Request", roundTrip: "On Request", rate: "₹10–11/km" },
  { vehicle: "Innova", oneWay: "On Request", roundTrip: "On Request", rate: "₹15–16/km" },
  { vehicle: "Tempo Traveller", oneWay: "On Request", roundTrip: "On Request", rate: "₹23–25/km" },
];

const defaultWhyChoose = [
  "Experienced local drivers",
  "Clean & AC vehicles",
  "Flexible pickup & drop",
  "Transparent pricing",
];

export const routesData = [
  {
    id: "udaipur-to-jaipur",
    from: "Udaipur",
    to: "Jaipur",
    distance: "400 km",
    duration: "6–7 hours",
    cardImage: "/images/jaipur.jpg",
    heroImage: "/images/jaipur 1.jpg",
    whyChoose: defaultWhyChoose,
    gallery: [
      { label: "City Palace", image: "/images/jaipur 2.jpg" },
      { label: "Hawa Mahal", image: "/images/jaipur 4.jpg" },
      { label: "Amer Fort", image: "/images/jaipur 3.jpg" },
    ],
    pricing: defaultPricing,
  },

  {
    id: "udaipur-to-jodhpur",
    from: "Udaipur",
    to: "Jodhpur",
    distance: "250 km",
    duration: "4–5 hours",
    cardImage: "/images/jodhpur1.jpg",
    heroImage: "/images/jodhpur 3.jpg",
    whyChoose: defaultWhyChoose,
    gallery: [
      { label: "Mehrangarh Fort", image: "/images/jodhpur1.jpg" },
      { label: "Jaswant Thada", image: "/images/jodhpur 3.jpg" },
    ],
    pricing: defaultPricing,
  },

  {
    id: "udaipur-to-jaisalmer",
    from: "Udaipur",
    to: "Jaisalmer",
    distance: "550 km",
    duration: "8–9 hours",
    cardImage: "/images/jaisalmer.jpg",
    heroImage: "/images/jaisalmer.jpg",
    whyChoose: defaultWhyChoose,
    gallery: [
      { label: "Jaisalmer Fort", image: "/images/jaisalmer.jpg" },
      { label: "Sam Sand Dunes", image: "/images/jaisalmer.jpg" },
    ],
    pricing: defaultPricing,
  },

  {
    id: "udaipur-to-mount-abu",
    from: "Udaipur",
    to: "Mount Abu",
    distance: "164 km",
    duration: "3 hours",
    cardImage: "/images/mountabu.jpg",
    heroImage: "/images/mountabu 1.jpg",
    whyChoose: [
      "Scenic Aravalli hill drive",
      "Same-day or overnight tour",
      "Local hill-route drivers",
    ],
    gallery: [
      { label: "Nakki Lake", image: "/images/mountabu 2.jpg" },
      { label: "Guru Shikhar", image: "/images/mountabu 3.jpg" },
    ],
    pricing: [
      { vehicle: "Sedan", oneWay: "₹3000", roundTrip: "₹5500", rate: "₹10/km" },
      { vehicle: "Innova", oneWay: "₹4500", roundTrip: "₹8000", rate: "₹15/km" },
      { vehicle: "Tempo Traveller", oneWay: "₹8000", roundTrip: "₹14000", rate: "₹25/km" },
    ],
  },

  {
    id: "udaipur-to-ranakpur",
    from: "Udaipur",
    to: "Ranakpur",
    distance: "94 km",
    duration: "2–3 hours",
    cardImage: "/images/ranakpur.jpg",
    heroImage: "/images/ranakpur 1.jpg",
    whyChoose: [
      "Direct NH58 route",
      "Same-day return possible",
      "Temple & fort sightseeing",
    ],
    gallery: [
      { label: "Ranakpur Jain Temple", image: "/images/ranakpur.jpg" },
      { label: "Kumbhalgarh Fort", image: "/images/ranakpur 2.jpg" },
    ],
    pricing: defaultPricing,
  },

  {
    id: "udaipur-to-nathdwara",
    from: "Udaipur",
    to: "Nathdwara",
    distance: "45 km",
    duration: "1 hour",
    cardImage: "/images/nathdwara.jpg",
    heroImage: "/images/nathdwara 1.jpg",
    whyChoose: defaultWhyChoose,
    gallery: [{ label: "Shrinathji Temple", image: "/images/nathdwara.jpg" }],
    pricing: defaultPricing,
  },

  {
    id: "udaipur-to-chittorgarh",
    from: "Udaipur",
    to: "Chittorgarh",
    distance: "115 km",
    duration: "2–3 hours",
    cardImage: "/images/chittorgarh.jpg",
    heroImage: "/images/chittorgarh 1.jpg",
    whyChoose: defaultWhyChoose,
    gallery: [{ label: "Chittorgarh Fort", image: "/images/chittorgarh.jpg" }],
    pricing: defaultPricing,
  },

  {
    id: "udaipur-to-sanwariya-seth",
    from: "Udaipur",
    to: "Sanwariya Seth",
    distance: "88 km",
    duration: "2 hours",
    cardImage: "/images/sanwariya.jpg",
    heroImage: "/images/sanwariya.jpg",
    whyChoose: defaultWhyChoose,
    gallery: [{ label: "Sanwariya Seth Temple", image: "/images/sanwariya.jpg" }],
    pricing: defaultPricing,
  },

  {
    id: "udaipur-to-nakoda-ji",
    from: "Udaipur",
    to: "Nakoda Ji",
    distance: "300 km",
    duration: "5–6 hours",
    cardImage: "/images/nakodaji.jpg",
    heroImage: "/images/nakodaji.jpg",
    whyChoose: defaultWhyChoose,
    gallery: [{ label: "Nakoda Ji Temple", image: "/images/nakodaji.jpg" }],
    pricing: defaultPricing,
  },

  {
    id: "udaipur-to-jawai",
    from: "Udaipur",
    to: "Jawai",
    distance: "150 km",
    duration: "3.5 hours",
    cardImage: "/images/jawai.jpg",
    heroImage: "/images/jawai.jpg",
    whyChoose: defaultWhyChoose,
    gallery: [{ label: "Jawai Leopard Safari", image: "/images/jawai.jpg" }],
    pricing: defaultPricing,
  },
];

/* ================= FLEET (UPDATED) ================= */

export const fleetData = [
  {
    id: 1,
    type: "Sedan",
    models: "Dzire / Etios",
    capacity: "4 Passengers",
    features: ["AC", "Clean Interior", "Music System"],
    image: "/images/car 7.jpeg",
  },
  {
    id: 2,
    type: "SUV / MUV",
    models: "Ertiga / Innova",
    capacity: "6–7 Passengers",
    features: ["AC", "Spacious", "Luggage Space"],
    image: "/images/car 9.jpeg",
  },
  {
    id: 3,
    type: "Premium",
    models: "Luxury Cars",
    capacity: "4 Passengers",
    features: ["Premium AC", "Luxury Interior", "On Request"],
    image: "/images/car 14.jpeg",
  },
];

/* ================= WHY CHOOSE US ================= */

export const whyChooseUsData = [
  {
    id: 1,
    title: "Experienced Drivers",
    description:
      "Verified drivers with strong local & highway route knowledge.",
    icon: "Shield",
  },
  {
    id: 2,
    title: "Clean & Comfortable Cars",
    description: "Sanitized, AC vehicles for a smooth and safe journey.",
    backgroundImage: "/images/car 19.jpeg",
    icon: "Sparkles",
  },
  {
    id: 3,
    title: "24/7 Availability",
    description: "Book taxis anytime via call or WhatsApp support.",
    icon: "Clock",
  },
  {
    id: 4,
    title: "Transparent Pricing",
    description: "No hidden charges. Honest per-km pricing.",
    icon: "BadgeCheck",
  },
];

/* ================= CONTACT ================= */

export const contactData = {
  phone: "+91 70141 31352",
  whatsapp: "917014131352",
  email: "info@bahubalicabs.com",
  address: "Udaipur, Rajasthan, India",
};
export const reviewsData = {
  rating: 5,
  totalReviews: 215,
  source: "Google",
  googleReviewUrl:
    "https://www.google.com/maps/search/?api=1&query=Bahubali+Cabs+Udaipur",

  reviews: [
    {
      name: "Amit Sharma",
      rating: 5,
      text: "Very punctual service. Driver was polite and the car was clean. Booked Udaipur to Mount Abu trip. Highly recommended!",
      date: "2 weeks ago",
    },
    {
      name: "Neha Jain",
      rating: 5,
      text: "Smooth airport pickup experience. On-time arrival and professional behavior. Will book again.",
      date: "1 month ago",
    },
    {
      name: "Rahul Mehta",
      rating: 4,
      text: "Good service and reasonable pricing. The vehicle was comfortable for our family trip.",
      date: "3 weeks ago",
    },
    {
      name: "Pooja Agarwal",
      rating: 5,
      text: "Booked for Udaipur sightseeing. Driver knew all routes well and was very cooperative.",
      date: "1 month ago",
    },
  ],
};

/* ================= NAV ================= */

export const navLinks = [
  { id: "home", label: "Home" },
  { id: "services", label: "Services" },
  { id: "routes", label: "Routes" },
  { id: "fleet", label: "Fleet" },
  { id: "udaipur-sightseeing", label: "Udaipur Sightseeing", path: "/udaipur-sightseeing" },
  { id: "gallery", label: "Gallery", path: "/gallery" },
  { id: "about-us", label: "About Us", path: "/about-us" },
  { id: "contact", label: "Contact" },
];

export const routeLinks = [
  { label: "Udaipur → Mount Abu", slug: "udaipur-to-mount-abu" },
  { label: "Udaipur → Jaipur", slug: "udaipur-to-jaipur" },
  { label: "Udaipur → Jodhpur", slug: "udaipur-to-jodhpur" },
  { label: "Udaipur → Jaisalmer", slug: "udaipur-to-jaisalmer" },
  { label: "Udaipur → Nakoda-ji", slug: "udaipur-to-nakoda-ji" },
  { label: "Udaipur → Ranakpur", slug: "udaipur-to-ranakpur" },
  { label: "Udaipur → Nathdwara", slug: "udaipur-to-nathdwara" },
  { label: "Udaipur → Chittorgarh", slug: "udaipur-to-chittorgarh" },
  { label: "Udaipur → Sanwariya", slug: "udaipur-to-sanwariya-seth" },
  { label: "Udaipur → Jawai", slug: "udaipur-to-jawai" },
];
